import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _class2, _descriptor, _hiders;
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { tracked } from "@glimmer/tracking";
import { registerDestructor } from "@ember/destroyable";
import Service from "@ember/service";
import { TrackedSet } from "@ember-compat/tracked-built-ins";
import { disableImplicitInjections } from "discourse/lib/implicit-injections";
let FooterService = disableImplicitInjections(_class = (_class2 = (_hiders = /*#__PURE__*/new WeakMap(), class FooterService extends Service {
  constructor() {
    super(...arguments);
    _classPrivateFieldInitSpec(this, _hiders, new TrackedSet());
    _initializerDefineProperty(this, "_showFooterOverride", _descriptor, this);
  }
  get showFooter() {
    return this._showFooterOverride ?? _classPrivateFieldGet(_hiders, this).size === 0;
  }
  set showFooter(value) {
    if (value === true) {
      this._showFooterOverride = null;
    } else {
      this._showFooterOverride = value;
    }
  }
  registerHider(destroyable) {
    _classPrivateFieldGet(_hiders, this).add(destroyable);
    registerDestructor(destroyable, () => _classPrivateFieldGet(_hiders, this).delete(destroyable));
  }
}), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "_showFooterOverride", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
})), _class2)) || _class;
export { FooterService as default };